import Button from "../../../shared/button";
import { useGetOutlookCredentialsQuery } from "../../../store/google-reservations/googleReservationsApi";
import { useGetOutlookAuthUrlQuery } from "../../../store/reservations/reservationsApi";

const Settings = () => {
  const { data: outlookAuthUrl } = useGetOutlookAuthUrlQuery({});
  const { data: outlookCredentials, isLoading } =
    useGetOutlookCredentialsQuery();

  const handleOutlookAuth = () => {
    window.location.assign(outlookAuthUrl.authUrl);
  };

  return (
    <div>
      <h4 className="page-title">Settings</h4>
      <div className="flex flex-wrap my-8 -mx-2">
        <div className="w-full md:w-6/12 px-2">
          <div className="bg-white p-4 rounded-md">
            <h5 className="text-2xl font-bold">Outlook Login</h5>
            <div className="my-3">
              {isLoading ? (
                <p className="text-sm">Loading...</p>
              ) : (outlookCredentials?.accessToken) ? (
                <p> You are already logged in </p>
              ) : (
                <Button
                  type="button"
                  label={"Login"}
                  onClickButton={handleOutlookAuth}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
